const setAreasOfExpertise = areasOfExpertise => ({
  type: 'SET_AREA_OF_EXPERTISE',
  areasOfExpertise,
});

export default setAreasOfExpertise;
